<template>  
  <v-layout v-if="mission && mission.misId" column fill-height>         
    <h2 class="mt-4 ml-4" >
      <mission-state :mission="mission" /> 
      {{mission.misLibelle}} 
      <mission-color small :uiid="mission_uiid" :mission="mission"/>
      <v-btn small icon @click.prevent="zoomOnMap" :title="$t('Pilot.MissionDrawer.SelectMissionTooltip')"><v-icon>mdi-crosshairs-gps</v-icon></v-btn>
      <v-btn small icon @click.prevent="$store.myActions.UI_TOGGLE_PATH_VISIBILITY(mission_uiid)" :title="$t(missionState.showPath?'Pilot.MissionDrawer.HideMissionTooltip':'Pilot.MissionDrawer.ShowMissionTooltip')"><v-icon>{{missionState.showPath?'mdi-eye':'mdi-eye-off'}}</v-icon></v-btn>
      <v-btn small v-if="!(missionState && missionState.infosPanelVisible)" icon @click.prevent="showInfos" :title="$t('Pilot.MissionDrawer.ShowInfosPanelTooltip')"><v-icon>mdi-information</v-icon></v-btn>
      <v-spacer />      
    </h2>         
    <mission-autogo :mission="mission" class="ml-3" style="flex:0 0" />   
    <mission-line-detail style="flex:1 1 auto" :uiid="mission_uiid"  class="ma-4" :mission="mission" />       
  </v-layout>  
</template>
<script>
  import { mapGetters } from 'vuex'  
  import MissionLineDetail from '@/components/mission/MissionLineDetail'  
  import MissionColor from '@/components/mission/MissionColor'
  import MissionState from '@/components/mission/MissionState' 
  import MissionAutogo from '@/components/mission/MissionAutogo.vue'   
  import {buildMissionUIStateId} from '@/models/ui/MissionUiState'  
  export default {
   components:{MissionLineDetail,MissionColor,MissionState,MissionAutogo},
   name: 'MissionDrawerInformation',   
    data() {
      return {                
      }
   },          
   computed: { 
       ...mapGetters([            
         'currentDetailMission',         
         'uistatebyuiid'
      ]),     
      mission_uiid() {
        return buildMissionUIStateId(this.mission.misId,"detail")
      },
      //recupere le state de travail
      missionState() { 
        //retourne un MapUiState
        return this.uistatebyuiid(this.mission_uiid)          
      },  
      mission(){
        return this.currentDetailMission && this.currentDetailMission.mission
      }
    },
    methods: {
      buildMissionUIStateId(missionId,suffixe) {
        return buildMissionUIStateId(missionId,suffixe)
      },
      zoomOnMap(){
        this.$store.myActions.UI_SELECT_MISSION_MAP({id:this.mission.misId,uiid:''})
      },
      showInfos(){
        if(!this.missionState.infosPanelVisible) this.$store.myActions.UI_TOGGLE_MISSION_INFO_PANEL_VISIBILITY(this.mission_uiid)
      }
    }
  }
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  
</style>
